import React from 'react';
import Link from '@material-ui/core/Link';
import CheckBoxOutlineBlankOutlined from '@material-ui/icons/CheckBoxOutlineBlankOutlined';
import CheckBoxOutlinedIcon from '@material-ui/icons/CheckBoxOutlined';
import SlideshowOutlined from '@material-ui/icons/SlideshowOutlined';
import TextField from "@material-ui/core/TextField/TextField";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from '@material-ui/icons/Delete';
import CloseIcon from '@material-ui/icons/Close';
import DoneIcon from '@material-ui/icons/Done';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import Grid from "@material-ui/core/Grid";
import DateFnsUtils from '@date-io/date-fns';
import {KeyboardDatePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';

import './TaskRow.css';
import ConfirmationDialog from "../components/ConfirmationDialog";

class TaskRow extends React.Component {
    constructor(props) {
        super(props);
        // console.log("TaskRow:", props);

        this.state = {
            edit: false,
        };

        this.changeStatus = this.changeStatus.bind(this);
        this.handleStatusChange = this.handleStatusChange.bind(this);
        this.cancel = this.cancel.bind(this);
        this.save = this.save.bind(this);
        this._handleTextFieldChange = this._handleTextFieldChange.bind(this);
        this._handleSelect = this._handleSelect.bind(this);
        this._handleDateChange = this._handleDateChange.bind(this);
    }

    // Icons:
    // To do:       CheckBoxOutlineBlankOutlined
    // In progress: SlideshowOutlined, PlayArrowOutlined, PlayCircleOutlineOutlined, PlayArrowSharp
    // Done:        CheckCircleOutlineOutlined, AssignmentTurnedInOutlined, DoneOutlined, CheckSharp

    render() {
        const showPlannedStart = false;
        const element = this.props.element;
        const isNew = !this.props.element.id;
        const selected = this.props.selected;
        const editMode = (selected && this.state.edit) || isNew;
        const changed = this.state;
        const values = {
            name: changed.name !== undefined ? changed.name : element.name,
            version: this.state.version,
        };
        const later = element.plannedStart && this.afterDate(element.plannedStart, new Date());
        // console.log("TaskRow:", element, ", selected:", selected, ", edit:", this.state.edit, ", isNew:", isNew);

        const iconStyle = {
            marginBottom: "-0.3em",
        };

        const gridAssigned = 2, gridPlannedStart = showPlannedStart ? 5 : 0;
        const isAssigned = element.assigned && element.assigned.length > 0;
        const isAssignedToMe = isAssigned && element.assigned[0].id === this.props.user.id;

        // const assigned1 = this.props.users.length > 0 && (isAssigned || editMode) &&
        //     <Grid id='assigned' item xs={gridAssigned}>
        //         <div className="assigned">
        //             <SelectUser
        //                 id="assigned"
        //                 users={this.props.users}
        //                 userMap={this.props.userMap}
        //                 noneLabel={"Unassigned"}
        //                 selected={element.assigned && element.assigned[0] ? element.assigned[0] : undefined}
        //                 edit={editMode}
        //                 onSelect={this._handleSelect}
        //             />
        //         </div>
        //     </Grid>;

        const assigned = element.status !== 'Done' && this.props.users.length > 0 &&
            <Grid id='assigned' item xs={gridAssigned}>
                <div className="assigned">
                    {!isAssigned &&
                        <AddCircleOutlineIcon
                            size="small"
                            onClick={() => {
                                this.updateElement({
                                    "assigned": this.props.user,
                                });
                            }}
                        />
                    }
                    {isAssigned && isAssignedToMe &&
                        <span
                            onClick={() => {
                                this.updateElement({
                                    "assigned": null,
                                });
                            }}
                        >
                            {element.assigned[0].name}
                        </span>
                    }
                    {isAssigned && !isAssignedToMe &&
                        element.assigned[0].name
                    }
                </div>
            </Grid>;

        const plannedStart = showPlannedStart && (this.state.date || editMode || (element.plannedStart && this.props.showDetails)) &&
            <Grid id='plannedStart' item xs={gridPlannedStart}>
                {/* Use MuiPickersUtilsProvider locale to start week on Monday in dialog. */}
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                        className='date-edit'
                        format="yyyy/MM/dd"
                        clearable={true}
                        value={this.state.date || element.plannedStart || null}
                        onChange={this._handleDateChange}
                    />
                </MuiPickersUtilsProvider>
            </Grid>;
        const buttons = (editMode &&
            <Grid item xs={4}>
                {isNew ?
                    <div className="task-create">
                        <IconButton aria-label="cancel"
                                    onClick={this.props.cancelNewTask}
                        >
                            <CloseIcon />
                        </IconButton>
                        <IconButton aria-label="ok"
                                    disabled={!values.name}
                                    onClick={ () => this.props.create({
                                        name: changed.name || element.name,
                                        assigned: element.assigned,
                                    }) }
                        >
                            <DoneIcon />
                        </IconButton>
                    </div> :
                    <div className="task-edit">
                        <IconButton aria-label="cancel"
                                    onClick={this.cancel}
                        >
                            <CloseIcon />
                        </IconButton>
                        {/* React warns that the state is changed from uncontrolled to controlled when values.name becomes non empty. */}
                        <IconButton aria-label="ok"
                                    onClick={this.save}
                                    disabled={!values.name}
                        >
                            <DoneIcon />
                        </IconButton>
                        <Tooltip title="Delete">
                            <IconButton aria-label="delete" onClick={() =>
                                this.setState({confirmationOpen: true} )
                            }>
                                <DeleteIcon/>
                            </IconButton>
                        </Tooltip>
                    </div>
                }
                </Grid>);

        let gridName = 12 - (assigned ? gridAssigned : 0); // - (!editMode && plannedStart ? gridPlannedStart : 0);

        return (
            <li className={"task" + (selected ? " selected" : "") + (later ? " later" : "")}>
                <Grid container>
                    <Grid id='name' item xs={gridName}>
                        {element.status === 'To do' ?       <CheckBoxOutlineBlankOutlined style={iconStyle} onClick={this.changeStatus}/> : null}
                        {element.status === 'In progress' ? <SlideshowOutlined            style={iconStyle} onClick={this.changeStatus}/> : null}
                        {element.status === 'Done' ?        <CheckBoxOutlinedIcon         style={iconStyle} onClick={this.changeStatus}/> : null}
                        {editMode ?
                            <TextField id='name'
                                       className='task-name-edit'
                                       value={values.name}
                                       onChange={this._handleTextFieldChange}
                                       autoFocus={true}
                                       placeholder="Task name"
                                       InputProps={{
                                           style: {
                                               // background: 'white',
                                               fontSize: 14,
                                               // width: 300,
                                               // marginLeft: 25,
                                               marginTop: 7,
                                           }
                                       }}
                            /> :
                            <Link
                                className={'name status-' + element.status}
                                component="button"
                                color={"inherit"}
                                onClick={() => {
                                    this.props.onSelect(element);
                                    this.setState({edit: true} );
                                }}
                            >
                                {element.name}
                            </Link>
                        }
                    </Grid>

                    {assigned}
                    {plannedStart}
                    {buttons}
                </Grid>
                <ConfirmationDialog
                    title={"Remove"}
                    text={"Remove task?"}
                    open={this.state.confirmationOpen}
                    onOK={() => {
                        this.setState({confirmationOpen: false} );
                        this.props.remove(element);
                    }}
                    onCancel={() => this.setState({confirmationOpen: false} )}
                />
            </li>
        );
    }

    handleStatusChange(event, newStatus) {
        const element = this.props.element;
        if(newStatus && newStatus !== element.status) {
            this.props.update(element, {
                status: newStatus
            }).then(
                () => {
                    this.setState({
                        version: new Date().getTime()
                    });
                }
            );
        }
    }

    _handleTextFieldChange(e) {
        var newState = {};
        newState[e.target.id] = e.target.value;
        this.setState(newState);
    }

    _handleSelect(id, value) {
        console.log("_handleSelect", id, value);
        var newState = {};
        newState[id] = value;
        this.updateElement(newState);
    }

    _handleDateChange(date, value) {
        console.log("_handleDateChange", date instanceof Date && !isNaN(date), date, value);

        this.setState({date: date, edit: false});
        if(date instanceof Date && !isNaN(date)) {
            // If I clear state here, it shows the date before for some reason, so don't do that.
            this.updateElement({plannedStart: date});
        } else {
            this.updateElement({plannedStart: null});
        }
    }

    changeStatus() {
        const element = this.props.element;
        const oldStatus = element.status;
        let ix = this.props.values.indexOf(oldStatus) + 1;
        if(ix >= this.props.values.length) {
            ix = 0;
        }
        let newStatus = this.props.values[ix];

        console.log("TaskRow.changeStatus: Change status from", oldStatus, "to", newStatus);
        this.updateElement({
            status: newStatus
        });
    }

    updateElement(values) {
        const element = this.props.element;
        console.log("updateElement", values);
        this.props.update(element, values).then(
            () => {
                // TODO Set lastUpdatedTimestamp from server.
                this.setState({
                    edit: false,
                    editAssigned: false,
                    version: new Date().getTime()
                });
            }
        );
    }

    cancel() {
        this.props.onSelect(null);
        this.setState({
            edit: false,
            name: undefined,
            editAssigned: false,
        });
    }

    save() {
        this.updateElement({
            name: this.state.name,
            plannedStart: this.state.plannedStart,
        });
    }

    afterDate(date, today) {
        if(date instanceof Date) {
            date = date.toISOString();
        }

        // Remove the time part after 'T' to only compare date, not time.
        return (date.split('T')[0] > today.toISOString().split('T')[0]);
    }
}

export default TaskRow;